export const INBOX_BRIDGE_APP_SLUG = 'inbox-pilot';
export const INBOX_BRIDGE_VERSION = 1;
export const INBOX_BRIDGE_TOKEN_KEY = 'poe:inbox-bridge-token';
